// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"068ecba1","234":"13029101","238":"8c631807","265":"c8f4b0d1","362":"acd5628e","444":"641990d2","453":"fa2b4e6c","467":"dc96ab42","799":"2f806877","858":"fae9fc2b","893":"af65f585"}[chunkId] + ".chunk.js";
};